import React, { useState, useEffect } from "react";
import "./FieldInputModal.css";

const FieldInputModal = ({ field, onSave, onCancel, initialValue = "" }) => {
  const [value, setValue] = useState(initialValue);
  const [error, setError] = useState("");

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const validateEmail = email => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = phone => {
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, "");
    // Must be 10 digits
    return digits.length === 10;
  };

  const formatPhone = phone => {
    // Remove all non-digit characters
    const digits = phone.replace(/\D/g, "");

    // Format as (XXX) XXX-XXXX
    if (digits.length === 0) return "";
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  };

  const handlePhoneChange = e => {
    const input = e.target.value;
    const formatted = formatPhone(input);
    setValue(formatted);
    setError("");
  };

  const handleSave = () => {
    setError("");

    // Validation based on field type
    if (field.field_type === "email") {
      if (!value.trim()) {
        setError("Email is required");
        return;
      }
      if (!validateEmail(value)) {
        setError("Please enter a valid email address");
        return;
      }
    } else if (field.field_type === "phone") {
      if (!value.trim()) {
        setError("Phone number is required");
        return;
      }
      if (!validatePhone(value)) {
        setError("Please enter a valid 10-digit phone number");
        return;
      }
    } else if (field.field_type === "text") {
      if (field.required && !value.trim()) {
        setError("This field is required");
        return;
      }
    } else if (field.field_type === "date") {
      if (!value) {
        setError("Date is required");
        return;
      }
    }

    onSave(value);
  };

  const renderInput = () => {
    switch (field.field_type) {
      case "text":
        return (
          <input
            type="text"
            value={value}
            onChange={e => {
              setValue(e.target.value);
              setError("");
            }}
            placeholder="Enter text..."
            autoFocus
            className="field-input"
          />
        );

      case "email":
        return (
          <input
            type="email"
            value={value}
            onChange={e => {
              setValue(e.target.value);
              setError("");
            }}
            placeholder="Enter email address..."
            autoFocus
            className="field-input"
          />
        );

      case "phone":
        return (
          <input
            type="tel"
            value={value}
            onChange={handlePhoneChange}
            placeholder="(555) 123-4567"
            maxLength={14}
            autoFocus
            className="field-input"
          />
        );

      case "date":
        return (
          <input
            type="date"
            value={value}
            onChange={e => {
              setValue(e.target.value);
              setError("");
            }}
            autoFocus
            className="field-input"
          />
        );

      default:
        return null;
    }
  };

  return (
    <div className="field-input-modal-overlay" onClick={onCancel}>
      <div
        className="field-input-modal-content"
        onClick={e => e.stopPropagation()}
      >
        <div className="field-input-modal-header">
          <h2>{field.label}</h2>
          <button className="close-btn" onClick={onCancel}>
            ×
          </button>
        </div>

        <div className="field-input-modal-body">
          {renderInput()}
          {error && <div className="field-input-error">{error}</div>}
        </div>

        <div className="field-input-modal-footer">
          <button className="btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn-primary" onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default FieldInputModal;
